var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.indexStyle==1)?_c('index-chart'):_vm._e(),(_vm.indexStyle==2)?_c('index-bdc'):_vm._e(),(_vm.indexStyle==3)?_c('index-task'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }